/**
 * KAN-684: закрытая система, самостоятельная регистрация.
 *
 * `GET /api/v1/auth/registration-status/` (без авторизации) отвечает
 * `{"allowed": bool}`. По умолчанию регистрация закрыта: аккаунты заводит
 * владелец организации в разделе "Пользователи".
 *
 * При закрытой регистрации `POST /api/v1/auth/register/` отвечает 403
 * `{"detail": REGISTRATION_CLOSED_MESSAGE, "code": REGISTRATION_CLOSED_CODE}`.
 */
import apiClient from './client';

export interface RegistrationStatus {
  allowed: boolean;
}

export const REGISTRATION_STATUS_QUERY_KEY = ['registration-status'] as const;

export const REGISTRATION_CLOSED_CODE = 'registration_closed';
export const REGISTRATION_CLOSED_MESSAGE = 'Регистрация закрыта. Доступ выдаёт администратор.';

export const registrationApi = {
  getStatus: async (): Promise<RegistrationStatus> => {
    const response = await apiClient.get<RegistrationStatus>('/api/v1/auth/registration-status/');
    return response.data;
  },
};

/** Ошибка axios с телом 403 `registration_closed`. */
export function isRegistrationClosedError(err: unknown): boolean {
  const error = err as { response?: { status?: number; data?: { code?: unknown } } };
  return error?.response?.status === 403 && error.response.data?.code === REGISTRATION_CLOSED_CODE;
}
